module.exports = __webpack_public_path__ + "static/media/delete_icn_dark.fccc7d10.png";